import { Button, Icon } from '@ps/isp-web-component-library';
import { Finishingpost } from '@ps/isp-web-component-library/icons/Finishingpost';
import type { MeetingBasedEventTypeId } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { SportsLink } from '@swf/sports/components';
import { EventTypeId } from '@swf/sports/types/eventType';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import {
  TXTWCL_Go_To_Greyhound_Racing,
  TXTWCL_Go_To_Horse_Racing,
  TXTWCL_You_have_reached_the_Finishing_ELL
} from './NoAntePostEventsMessage.messages.json';
import styles from './NoAntePostEventsMessage.scss';

const translationMap: Record<MeetingBasedEventTypeId, TranslationTag> = {
  [EventTypeId.HORSE_RACING]: TXTWCL_Go_To_Horse_Racing,
  [EventTypeId.GREYHOUND_RACING]: TXTWCL_Go_To_Greyhound_Racing
};

const NoAntePostEventsMessage: React.FC = () => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);
  const parsedEventTypeId = Number(eventTypeId);

  if (!isMeetingBasedEventTypeId(parsedEventTypeId)) return null;

  return (
    <div className={styles.container}>
      <Icon icon={Finishingpost} className={styles.finishingPost} size="xxl" />
      <span className={styles.finishedText}>
        <Translation {...TXTWCL_You_have_reached_the_Finishing_ELL} />
      </span>
      <Button
        as={SportsLink}
        values={{ eventTypeSlug, eventTypeId }}
        alias="sportsAnimalRacingNext"
      >
        <Translation {...translationMap[parsedEventTypeId]} />
      </Button>
    </div>
  );
};

export default NoAntePostEventsMessage;
